import { Component, OnInit } from "@angular/core";
import { SignupService } from "src/app/services/signup.service";
import { TitleAndDescriptionsService } from "src/app/services/titles-and-descriptions.service";
import { WatcherService } from "src/app/services/watcher.service";

@Component({
    selector: "app-stores-main", 
    templateUrl: "./stores-main.component.html",
    styleUrls: ["./stores-main.component.css"],
})

export class StoresMainComponent implements OnInit {

    lang: string = 'en';
    hostCountriesCount;
    constructor(
        private watcherService: WatcherService,
        private metaService: TitleAndDescriptionsService,
        private signupService: SignupService
    ) {
        
    }
    
    ngOnInit(): void {
       this.hostCountriesCount = localStorage.getItem('hostCountriesCount')
        this.watcherService.getLang().subscribe(lang => {
            this.lang = lang;
        })

        this.metaService.updateWebPageTitle(`Best International Stores: How to Shop Globally - Shippn`);
        this.metaService.updateWebsiteDescription(`Explore the best international stores with Shippn’s guide on how to shop globally. Get tips on accessing top global brands and exclusive deals.`);
    }
}